document.addEventListener('DOMContentLoaded', function(e) {
    let scrollHero = document.querySelector('.scroll-hero');
    if (scrollHero) {
        let last = scrollHero.querySelector('.right span:last-child');
        last.setAttribute('style', `margin-bottom: ${scrollHero.scrollHeight - last.scrollHeight}px`);

        function setMargin() {
            last.setAttribute('style', `margin-bottom: ${scrollHero.scrollHeight - last.scrollHeight}px`);
            console.log(scrollHero.scrollHeight,last.scrollHeight);
        }
           
        new ResizeObserver(setMargin).observe(last);
    }
})